import { useAuth } from '@/modules/context/AuthContext'
import {
    Daycare,
    DaycarePredefinedMessage,
    DaycarePredefinedMessageType,
    DaycareType,
    ExpirationDuration
} from '@/types/Daycare'

interface CurrentDaycareProps {
    currentDaycare: Daycare
    isRpeOrLaep: boolean
    defaultExpirationDuration: ExpirationDuration
    getDefaultDaycareMessage(type: DaycarePredefinedMessageType): string | undefined
}

export function useCurrentDaycareInfos(): CurrentDaycareProps {
    const { user } = useAuth()

    if (!user) throw new Error('User not connected')
    if (!user.currentDaycare) throw new Error('No current daycare')

    const currentDaycare: Daycare = user.currentDaycare

    const isRpeOrLaep: boolean = currentDaycare.type === DaycareType.rpe || currentDaycare.type === DaycareType.laep

    const defaultExpirationDuration: ExpirationDuration = currentDaycare.expirationDuration

    function getDefaultDaycareMessage(type: DaycarePredefinedMessageType): string | undefined {
        return currentDaycare.predefinedMessages?.find((message: DaycarePredefinedMessage) => message.type === type)
            ?.message
    }

    return { currentDaycare, isRpeOrLaep, defaultExpirationDuration, getDefaultDaycareMessage }
}
